<template>
  <div id="map"></div>
</template>

<script>
const GoogleMapsLoader = require('google-maps')
const MarkerClusterer = require('node-js-marker-clusterer');
export default {
  components: {
  },
  data () {
    return {
      points:[],
      markersC: [],
      google:'',
    }
    },
methods: {
  initMap: function(datas) {
     GoogleMapsLoader.KEY = 'AIzaSyBHuFnXcvRwI6SNmxF-1MsM36xQH0zoxbE';
        var that = this;
        GoogleMapsLoader.load(function(google) {
        
        var map = new google.maps.Map(document.getElementById('map'), {
            center: {lat: 13.7561783, lng: 100.149830},
            zoom: 9
        });
        that.setMarkers(datas,map);
  });
  
},
 setMarkers:function(datas,map){
      var that = this;
      var points = [];
      for(var i = 0; i < datas.length; i++) {
        var companyListJSON = [];
        companyListJSON.push(datas[i]["location"][0].cityName)
        companyListJSON.push(Number(datas[i]["location"][1].latitute))
        companyListJSON.push(Number(datas[i]["location"][2].longitude))
        points.push(companyListJSON);
      }
  var infowindow = new google.maps.InfoWindow();
	for (var i = 0; i < points.length; i++) {
		var point = points[i];
		var marker = new google.maps.Marker({
												position: {lat: point[1], lng: point[2]},
												map: map,
												title: point[0],
											});
    that.markersC.push(marker);
		var contentString = '<div class="marker-infowindow">' +
							'<h2>'+point[0]+'</h1>'+
							'<div><a target="_blank" href="https://tutoandco.colas-delmas.fr/developpement/inserer-carte-google-maps-wordpress/?utm_source=jsfiddle&utm_medium=website">Voir le tuto complet</a></div></div>';


		google.maps.event.addListener(marker, 'click', (function(marker, i, contentString) {
			return function() {
				infowindow.setContent(contentString);
				infowindow.open(map, marker);
			}
		})(marker, i, contentString));
	}
      // Add a marker clusterer to manage the markers.
  var markerCluster = new MarkerClusterer(map, that.markersC,
  {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'}
  );
 }
},


}
</script>